import { fetcher } from "helpers/fetcher";

import { TUpdateBUProfileReq, TUpdateBUProfileRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const updateBUProfile = async (payload: TUpdateBUProfileReq) => {
  return await fetcher<TUpdateBUProfileRes, TUpdateBUProfileReq["data"]>(
    ENDPOINT.BU.UPDATE_BU_PROFILE,
    {
      data: payload.data,
      headers: {
        [API_HEADER.VERSION]: ENDPOINT.BU.UPDATE_BU_PROFILE.version,
        [API_HEADER.BU_ID]: payload.buId,
      },
    }
  );
};

export const mutationUpdateBUProfile = async (payload: TUpdateBUProfileReq) => {
  return (await updateBUProfile(payload)).data;
};

mutationUpdateBUProfile._key = (payload: TUpdateBUProfileReq) => [
  ENDPOINT.BU.UPDATE_BU_PROFILE.url,
  payload,
];
